// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"c329240a","143":"b19827e0","192":"488ce212","295":"cdf90009","349":"a8122ecd","351":"585e859f","453":"c32d2892","592":"ce779b28","655":"d3cbcecf","813":"bd834246","866":"53ad8929","927":"6a5c446b","963":"b2508c6f"}[chunkId] + ".chunk.js";
};